import {
  IPlacesApiAdapter,
  PlaceDetails,
  PlacesApiAdditionalOptions,
  PlaceSuggestion,
  ViaCepResponse,
} from '../types';
import { CEP } from '../utils/CEP';
import { safeCall } from '../utils/safecall';
import { viaCepSearch } from '../utils/viacep';

export class ViaCepPlacesServiceDecorator implements IPlacesApiAdapter {
  private readonly api: IPlacesApiAdapter;

  constructor(placesApi: IPlacesApiAdapter) {
    this.api = placesApi;
  }

  async suggestPlaces(input: string): Promise<PlaceSuggestion[]> {
    const normalizedInput = await ViaCepPlacesServiceDecorator.decoratePredictInput(input);

    return this.api.suggestPlaces(normalizedInput);
  }

  searchPlaces(input: string, options?: PlacesApiAdditionalOptions): Promise<PlaceDetails[]> {
    return this.api.searchPlaces(input, options);
  }

  getPlaceDetails(placeId: string, options?: PlacesApiAdditionalOptions): Promise<PlaceDetails> {
    return this.api.getPlaceDetails(placeId, options);
  }

  private static async decoratePredictInput(query: string): Promise<string> {
    const cep = safeCall(() => new CEP(query));

    if (!cep) return query;

    try {
      const data = await viaCepSearch(query);
      return ViaCepPlacesServiceDecorator.mountQuery({ ...data, cep: data.cep ?? query });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Error fetching CEP data:', err);
      return query;
    }
  }

  private static mountQuery(data: ViaCepResponse): string {
    const { localidade, logradouro, bairro, uf, cep } = data;

    return `${logradouro ?? ''} - ${bairro ?? ''}, ${localidade ?? ''} - ${uf ?? ''}, ${cep ?? ''}`;
  }
}
